import React from 'react';
import Icon from '../atoms/Icon';

function NFLIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <circle cx="16" cy="16" r="16" fill="currentColor"/>
      <path d="M13.2923 19.8462H11.2492L7.77845 15.0954V19.8462H5.66153V11.6369H7.83999L11.1631 16.1539V11.6369H13.2923V19.8462ZM16.889 19.8462H14.7721V11.6369H20.7906V13.4831H16.889V14.7631H20.7044V16.6092H16.889V19.8462ZM27.314 19.8462H21.8986V11.6369H24.0156V18H27.314V19.8462Z" fill="white"/>
    </Icon>
  );
}

export default React.forwardRef(NFLIcon);
